

export const moduleTypes = [
    { label: "影视模块", value: 1 },
    { label: "暗网模块", value: 2 },
    { label: "发现模块", value: 3 },
    { label: "社区模块", value: 4 },
    { label: "种子模块", value: 5 },
    { label: "黄游模块", value: 6 },
    { label: "写真模块", value: 7 },
]

export const topicTypes = [
    { label: "默认", value: 0 },
    { label: "视频帖子", value: 1 },
    { label: "种子帖子", value: 2 },
    { label: "黄游帖子", value: 3 },
]

export function getTypeLabel(val, types) {
    const type = types.find(v => v.value == val)
    if (type) {
        return type.label
    }
    return ''
}

const newsTypeMapper = {
    SP: '短视频帖子',
    MOVIE: '长视频帖子',
    COVER: '图片帖子',
    SEED_LINK: '种子贴子',
    AD_SP: '视频广告',
    YELLOW_GAME: '黄游帖子',
    AD: '图片广告'
}

export function getNewsTypeName(key) {
    return newsTypeMapper[key || 'AD'] || newsTypeMapper.AD
}

const tagStyles = 'success/warning/danger/success'.split('/')
const tagStylesCount = tagStyles.length
export function getTagStyle(val) {
    return tagStyles[val % tagStylesCount]
}

/// 跑马灯类型
export const marqueeTypes = [
    {
        label: "视频模块",
        value: 0,
    },
    // {
    //     label: "广场模块",
    //     value: 1,
    // }
]

export function getMarqueeTypeName(val) {
    return getTypeLabel(val, marqueeTypes)
}

/// 视频权限
export const videoPermissionTypes = [
    { label: 'VIP会员', value: 0 },
    { label: '金币购买', value: 1 },
    { label: '免费', value: 2 },
]

/**
 * 奖品类型
 */
export const priceTypes = [
    // { label: "活跃值", value: 1 },
    { label: "金币", value: 2 },
    { label: "金币视频观影券", value: 3 },
    { label: "ai脱衣免费次数", value: 4 },
    { label: "会员卡", value: 5 },
    { label: "会员折扣券", value: 6 },
    { label: "实物", value: 7 },
    { label: "积分", value: 8 },
]

/**
 * 排序类型0-正序 1-倒序
 */
export const sortTypes = [
    { label: "正序", value: 0 },
    { label: "倒序", value: 1 },
]

export const passTypes = [
    { label: '上架', value: 1 },
    { label: '下架', value: 2 }
]

/**
 * 列表最大总数
 */
export const maxTotalTypes = [1000, 2000, 5000, 10000].map(v => ({ label: v.toString(), value: v }))